export default __webpack_public_path__ + "static/media/video.f4ac6f5a.mp4";